// ─────────────────────────────────────────────────────────────────────────────
// useZoom — the map's discrete zoom stepper.
//   Zoom is a fixed ladder of levels rather than free pinch/scroll: the toolbar
//   renders one bar per level, so the state is just an index into ZOOM_LEVELS.
//
//   FIT_SCALE is why level 1 is not 1:1. The dotted-map SVG fills its viewBox
//   edge to edge and the canvas is locked to that same aspect ratio, so an
//   unscaled map would touch all four borders; the design frames the world with
//   a margin instead. Shrink or grow this to change that margin.
// ─────────────────────────────────────────────────────────────────────────────
import { useState } from "react";

export const ZOOM_LEVELS = [1, 1.3, 1.7, 2.1, 2.6, 3.1, 3.6];

const FIT_SCALE = 0.85;

/**
 * @returns {{
 *   index: number, scale: number,
 *   canZoomIn: boolean, canZoomOut: boolean,
 *   zoomIn: () => void, zoomOut: () => void,
 * }}  `scale` is the final transform for the viewport — FIT_SCALE already applied.
 */
export function useZoom() {
  const [index, setIndex] = useState(0);
  const maxIndex = ZOOM_LEVELS.length - 1;

  return {
    index,
    scale: FIT_SCALE * ZOOM_LEVELS[index],
    canZoomOut: index > 0,
    canZoomIn: index < maxIndex,
    zoomOut: () => setIndex((i) => Math.max(0, i - 1)),
    zoomIn: () => setIndex((i) => Math.min(maxIndex, i + 1)),
  };
}
